/* Email capture, behaviour only.

   This file used to build the forms. It must never do that again: a form the
   browser creates has no Shopify captcha token, the POST comes back "Missing
   CAPTCHA token", and the address is silently thrown away while the visitor is
   shown a thank you. The markup comes from snippets/hy-capture.liquid. Setting
   the value of a field inside Shopify's own form is fine. Creating one is not.

   THE COOKIE BANNER. Shopify's privacy banner is fixed to the bottom of the
   viewport, so it sat on top of the footer band and the visitor never saw the
   form at all. The band is given bottom padding equal to the banner's height
   while it is up. The welcome sheet comes FIRST: it no longer waits for the
   banner to be answered, because most visitors never answer it and the sheet
   then never appeared. While the sheet is open the banner is set aside
   (html.hycap-open, see hy-sign.css) and it comes straight back when the
   sheet closes, so consent is still asked before anything non essential runs.
   One decision at a time, email first, cookies second.

   THE DISMISS KEY IS VERSIONED. Until 23 September the hidden sheet sat
   invisibly over the whole page, and any tap on it counted as a tap on the
   backdrop, which closes the sheet and remembers the dismissal for 30 days.
   Everyone who touched the site that day was silently opted out. Moving to a
   new key gives them the sheet once, properly.

   TWO THINGS THAT BIT EARLIER, worth keeping written down.

   The tile images ship as data-src. A lazy image inside a hidden element is
   never judged near the viewport, so the browser never fetched them and three
   empty squares rendered. They load when the sheet opens.

   The class that animates the sheet in used to be added inside a double
   requestAnimationFrame, and rAF does not run in a background tab. The timer
   fires happily in the background, so hidden came off while is-up never went
   on: the visitor switched back to a half painted sheet with no backdrop over
   the page. Opening waits for the tab to be visible, with a timeout fallback.

   WHEN THE SHEET OPENS (4 Nov, r9; Kamil: the pop up was leaking clicks
   on phones). Once per browser session, never for 7 days after a close,
   never after a sign up, never on cart, checkout or the early access page.
   Never on the first page of a visit. Never while the bag, the menu or the
   filter drawer is open, and never within 60 seconds of an add to bag (the
   time is kept for the session, so it carries over to the next page).
   Ad sessions: a landing address carrying gclid, gbraid, wbraid, fbclid or
   utm_medium=cpc, paid or ppc marks the whole session; such visitors never
   see it on a product page or the cart.
   Phones: only after at least 3 pages AND 45 seconds on the site, or after
   20 seconds without a touch or scroll on the home page or a catalogue.
   Desktop: as before (6 seconds or 40% scroll; product pages 60% scroll
   and 40 seconds; exit intent), except that an ad session waits until its
   second page.
*/
(function () {
  'use strict';

  var DISMISS = 'haloyard:bf-dismissed-v3';
  var DONE = 'haloyard:capture-done';
  var SEEN = 'haloyard:bf-seen';
  var DAYS7 = 7 * 24 * 60 * 60 * 1000;
  var PV = 'hy:pv', T0 = 'hy:t0', AD = 'hy:ad', LASTADD = 'hy:lastAdd';

  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function sstore(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function sread(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function seenThisSession() { return sread(SEEN) === '1'; }

  if (/[?&]customer_posted=true/.test(window.location.search)) store(DONE, '1');

  /* ---- The visit: pages seen, start time, ad landing ---- */
  var pv = (Number(sread(PV)) || 0) + 1;
  sstore(PV, String(pv));
  if (!sread(T0)) sstore(T0, String(Date.now()));
  var q = window.location.search;
  if (/[?&](gclid|gbraid|wbraid|fbclid)=/i.test(q) || /[?&]utm_medium=(cpc|paid|ppc)(&|$)/i.test(q)) sstore(AD, '1');
  var adSession = sread(AD) === '1';
  var phone = window.matchMedia('(max-width: 749px)').matches || (window.matchMedia('(hover: none)').matches && window.matchMedia('(pointer: coarse)').matches);
  function siteSeconds() { return (Date.now() - (Number(sread(T0)) || Date.now())) / 1000; }

  function done() { return read(DONE) === '1'; }
  function dismissedRecently() {
    var t = read(DISMISS);
    return !!t && (Date.now() - Number(t) < DAYS7);
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var band = document.querySelector('[data-hycap-band]');
  var mod = document.querySelector('[data-hycap-mod]');
  var isProduct = document.body.classList.contains('template-product');

  /* A visitor who has just added something is heading for the bag, not for
     a sign up. Clicks on any add control and submits of the product form
     are timestamped for the session; open() stays shut for 60 seconds after. */
  function markAdd() { sstore(LASTADD, String(Date.now())); }
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest && ev.target.closest('[data-add-btn], [data-buybar-add], [data-quick-add], [data-qadd], [data-hy-pair-add], [data-hy-set-add], [data-hy-bd-add], .tile-add, .shopify-payment-button');
    if (t) markAdd();
  }, true);
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.getAttribute && f.getAttribute('data-type') === 'add-to-cart-form') markAdd();
  }, true);
  function justAdded() { return Date.now() - (Number(sread(LASTADD)) || 0) < 60000; }
  function bagBusy() {
    return !!document.querySelector('.drawer.is-open, .hy-dr.is-open, .hy-coll.is-filtering, [data-hy-vw]:not([hidden])') ||
      document.body.style.overflow === 'hidden' || justAdded();
  }

  /* ---- Shopify's privacy banner ---- */
  function consentBanner() {
    var el = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (!r.height || getComputedStyle(el).display === 'none') return null;
    return { el: el, height: Math.round(r.height) };
  }

  function syncBandPadding() {
    var b = consentBanner();
    document.documentElement.style.setProperty('--hycap-cookie', b ? b.height + 'px' : '0px');
    return b;
  }

  syncBandPadding();
  var bannerWatch = setInterval(syncBandPadding, 900);
  setTimeout(function () { clearInterval(bannerWatch); syncBandPadding(); }, 120000);
  window.addEventListener('resize', syncBandPadding);

  /* ---- Band ---- */
  if (band) {
    var foot = document.querySelector('.footer') || document.querySelector('footer');
    if (foot && foot.parentNode) foot.parentNode.insertBefore(band, foot);
    band.removeAttribute('hidden');
  }
  var success = document.querySelector('[data-hycap-success]');
  if (success) {
    store(DONE, '1');
    setTimeout(function () { success.scrollIntoView({ block: 'center' }); }, 60);
  }

  if (!mod) return;

  var panel = mod.querySelector('[data-hycap-panel]');
  var lastFocus = null;
  var shown = false;
  var pending = false;

  function loadTiles() {
    Array.prototype.forEach.call(mod.querySelectorAll('img[data-src]'), function (img) {
      if (img.getAttribute('src')) return;
      if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
      img.setAttribute('src', img.getAttribute('data-src'));
    });
  }

  /* ---- Room picker ---- */
  var tagsField = mod.querySelector('[data-hycap-tags]');
  var sub = mod.querySelector('[data-hyroom-sub]');
  var tiles = Array.prototype.slice.call(mod.querySelectorAll('[data-hyroom]'));
  var subDefault = sub ? sub.textContent : '';

  tiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      var was = tile.getAttribute('aria-pressed') === 'true';
      tiles.forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });

      if (was) {
        if (tagsField) tagsField.value = 'newsletter';
        if (sub) sub.textContent = subDefault;
        return;
      }

      tile.setAttribute('aria-pressed', 'true');
      var room = tile.getAttribute('data-hyroom');
      var label = tile.getAttribute('data-label') || room;
      if (tagsField) tagsField.value = 'newsletter, room-' + room;
      if (sub) sub.textContent = 'Noted. We will lead with ' + label + ' pieces.';
    });
  });

  /* ---- Sheet ---- */
  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null && !el.disabled; }
    );
  }

  function reveal() {
    if (mod.classList.contains('is-up')) return;
    mod.classList.add('is-up');
    var x = mod.querySelector('[data-hycap-close]');
    if (x) x.focus({ preventScroll: true });
  }

  function retryLater() {
    if (pending) return;
    pending = true;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (tries > 150) { clearInterval(t); pending = false; return; }
      if (document.hidden) return;
      clearInterval(t);
      pending = false;
      open();
    }, 1000);
  }

  function open() {
    if (shown || done() || dismissedRecently() || seenThisSession()) return;
    if (/\/(cart|checkout|account|tools|challenge)/.test(window.location.pathname)) return;
    if (pv < 2) return;
    if (adSession && isProduct) return;
    if (/\/pages\/black-friday-early-access/.test(window.location.pathname) || document.querySelector('.bfl')) return;
    if (bagBusy()) return;

    /* Wait for the tab to be visible. The consent banner no longer blocks this:
       email first, then the banner comes back when the sheet closes. */
    if (document.hidden) { retryLater(); return; }

    shown = true;
    sstore(SEEN, '1');
    lastFocus = document.activeElement;
    loadTiles();
    mod.removeAttribute('hidden');
    document.documentElement.classList.add('hycap-open');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(reveal); });
    setTimeout(reveal, 80);
  }

  function close() {
    mod.classList.remove('is-up');
    store(DISMISS, String(Date.now()));
    document.documentElement.classList.remove('hycap-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      mod.setAttribute('hidden', '');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }, reduce ? 0 : 340);
  }

  var closeBtn = mod.querySelector('[data-hycap-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);
  mod.addEventListener('click', function (ev) { if (ev.target === mod) close(); });

  document.addEventListener('keydown', function (ev) {
    if (!mod.classList.contains('is-up')) return;
    if (ev.key === 'Escape') { close(); return; }
    if (ev.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (ev.shiftKey && document.activeElement === first) { last.focus(); ev.preventDefault(); }
    else if (!ev.shiftKey && document.activeElement === last) { first.focus(); ev.preventDefault(); }
  });

  if (done() || dismissedRecently() || seenThisSession()) return;

  var fired = false;
  var isBrowse = document.body.classList.contains('template-index') || document.body.classList.contains('template-collection');
  /* Try now; if a drawer is open or an add was just made, look again. */
  function tryOpen() {
    if (fired || shown) return;
    if (bagBusy()) { setTimeout(tryOpen, 5000); return; }
    fired = true;
    open();
  }

  if (pv < 2 || (adSession && isProduct)) {
    /* First page of the visit, or an ad visitor on a product page: nothing. */
  } else if (phone) {
    /* 3 pages and 45 seconds on the site, never sooner than 5 seconds into
       this page; or 20 seconds idle on the home page or a catalogue. */
    if (pv >= 3) setTimeout(tryOpen, Math.max(5000, (45 - siteSeconds()) * 1000));
    if (isBrowse) {
      var idleT = null;
      var idle = function () { clearTimeout(idleT); idleT = setTimeout(tryOpen, 20000); };
      ['scroll', 'touchstart', 'keydown', 'click'].forEach(function (n) { window.addEventListener(n, idle, { passive: true }); });
      idle();
    }
  } else if (isProduct) {
    /* Desktop product pages: 60% scroll AND 40 seconds. */
    var scrolled = false, waited = false;
    var check = function () { if (scrolled && waited) tryOpen(); };
    setTimeout(function () { waited = true; check(); }, 40000);
    window.addEventListener('scroll', function onScrollP() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= 0.6) {
        scrolled = true;
        window.removeEventListener('scroll', onScrollP);
        check();
      }
    }, { passive: true });
  } else {
    setTimeout(tryOpen, 6000);
    window.addEventListener('scroll', function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.4) {
        window.removeEventListener('scroll', onScroll);
        tryOpen();
      }
    }, { passive: true });
  }

  if (!phone && window.matchMedia('(hover:hover)').matches && pv >= 2) {
    document.addEventListener('mouseout', function onOut(ev) {
      if (ev.clientY <= 0 && !ev.relatedTarget) {
        if (bagBusy()) return;
        document.removeEventListener('mouseout', onOut);
        open();
      }
    });
  }
})();